export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
  'pages_read_engagement',
];

export const INSTAGRAM_SCOPES = [
  'instagram_basic',
  'instagram_manage_messages',
];

// Reading and moderating comments. Both require Meta App Review, so they are
// requested only for accounts that have comment management switched on.
export const FACEBOOK_COMMENT_SCOPES = [
  'pages_read_user_content',
  'pages_manage_engagement',
];

// Publishing page posts. Reviewed independently of the comment scopes.
export const FACEBOOK_PUBLISHING_SCOPES = ['pages_manage_posts'];

// Array form, so callers that need to diff against Facebook's granted-permission
// list share exactly the list we request rather than re-deriving it.
export const facebookLoginScopeList = ({
  includeInstagramScopes = false,
  includeCommentScopes = false,
  includePublishingScopes = false,
} = {}) => {
  const scopes = [...FACEBOOK_PAGE_SCOPES];
  if (includeInstagramScopes) {
    scopes.push(...INSTAGRAM_SCOPES);
  }
  if (includeCommentScopes) {
    scopes.push(...FACEBOOK_COMMENT_SCOPES);
  }
  if (includePublishingScopes) {
    scopes.push(...FACEBOOK_PUBLISHING_SCOPES);
  }
  return scopes;
};

export const buildFacebookLoginScopes = options =>
  facebookLoginScopeList(options).join(',');

// Every FB.login call site (new page connect, existing inbox reauthorize) has
// to request the comment/publishing scopes on the same basis: the account's
// comment_management and post_publishing feature flags. Shared here so the
// flag-name -> scope mapping can't drift between call sites.
export const facebookScopeFlagsForAccount = (
  isFeatureEnabledOnAccount,
  accountId
) => ({
  includeCommentScopes: isFeatureEnabledOnAccount(
    accountId,
    'comment_management'
  ),
  includePublishingScopes: isFeatureEnabledOnAccount(
    accountId,
    'post_publishing'
  ),
});
